import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { timeout, map, catchError, finalize } from 'rxjs/operators';
import { empty, TimeoutError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonFunctionsService } from '../services';

// import {  NotifcationStoreService } from '../services/index';
@Injectable()
export class ClientTokenInterceptor implements HttpInterceptor {

  loaderExclusionList: any = [
    "/client/search"
  ]
  spinnerCount = 0;

  constructor(
    private spinner: NgxSpinnerService,
    private commonFunctionsService: CommonFunctionsService
    // private notifStore: NotifcationStoreService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.spinnerCount < 0) this.spinnerCount = 0;
    // if there is a no-loader param on the request headers, dont show loader
    if (this.showLoader(request.url) && !request.headers.get('no-loader')) {
      // if(!this.commonFunctions.isMeetingRoom()){
      this.spinner.show();
      // }
      this.spinnerCount++; // keeps track of how many calls are out, so that once they are all done, only then do we hide the spinner
    }
    let modifiedReq: any;
    if (request.url.indexOf('bookingbug') !== -1 || request.url.indexOf('jrni') !== -1  || request.url.indexOf('ffs4ovo9dg') !== -1 || request.url.indexOf('localhost') !== -1 || request.url.indexOf('bookinglab') !== -1) {
      modifiedReq = request;
    }
    else {
      modifiedReq = request.clone({
        headers: request.headers.set('clienttoken', environment.clientToken).set('Content-Type', 'application/json')
      });
    }

    return next.handle(modifiedReq).pipe(timeout(45000), map(res => {
      return res;
    }), finalize(() => {
      setTimeout(() => {
        this.checkIfHide(request),
          1000
      });

    }), catchError(err => {
      // this.notifStore.onNotify(err);
      if (!request.headers.get("nounspinn")) {
        console.log(err.status);
        console.log(err);
        if (err.status > 499 ) {
          this.commonFunctionsService.setRequestError(err);
        } else {
          throw err;
        }
        setTimeout(() => {
          this.checkIfHide(request),
            1000
        });
      } else {
        console.log("404 from jrni just means there was no basket to delete")
      }
      if (err instanceof TimeoutError)
        console.error('Timeout has occurred', request.url);
      return empty();
    }),
    );
  }

  // allows the network call's spinners to overlap. if there is no wait it will flash on and off when there is a chain of them
  checkIfHide(request: any) {
    if (this.showLoader(request.url)) {
      this.spinnerCount--;
    }
    if (this.spinnerCount <= 0) {
      this.spinner.hide()
    }
  }

  showLoader(url: string) {
    let show = true;

    this.loaderExclusionList.forEach((path: string) => {
      if (url.indexOf(path) != -1) {
        show = false;
        return;
      }
    });

    return show;
  }
}
